import styled from '@emotion/styled';
import { FilterContainer } from '../../style';

export const Container = styled(FilterContainer)`
  max-width: 260px;
`;
